import { _HLB_HOST } from "@/tools/constants";
import { Utils } from '../../../tools/utils'


  // 跳转活动落地页
  const HTML_URL = Utils.isHLB()?
      `http://${_HLB_HOST[0]}/activity/launch/index.html` :
      `https://${window.location.host}/activity/launch/index.html`;
  // 跳转页面
  export const jumpToLaunch = (item ={},props = {}) => {
    let {
      activityType = '', //活动类型 1 加佣活动 2 推广活动 3其他活动
      landingPageType = '', //落地页类型 1自定义链接 2保险产品详情页 3图片 4音频 5视频 6pdf
      spuId = '',
      landingPagePath = '', //跳转地址
      aplandingPicturePath = '',//落地页类型为图片/文件时图片地址
    } = item;
    if (item.isLocal === 1) {// 如果来自于本地json，需要跳转外部链接
      openPage(item.redirectUrl)
    }else {
      activityType += '';// 转为string
      switch(activityType) {
        case '1': // 加佣活动
          props.history.push(`/activity/activitylist/detail/${item.activityRuleId || ''}`);
          break;
        case '2':
          if(landingPageType == '2') {// 跳转产品库-产品详情
            props.history.push(`/productSys/productRepository/detail/${getProDetailParams(item)}`)
          }else if (landingPageType == '3'){// 二级跳，详情页是产品库的
            openPage(getLaunchUrl(item))
          }else {// 跳转后端提供的链接
            openPage(landingPagePath)
          }
          break;
        case '3':
          if (landingPageType == '3') {// 查看图片，为了全屏铺开展示，使用html打开此图
            seeImageInHtml(landingPagePath)
          }
          openPage(landingPagePath)
          break;
        default:
          break;
      }
    }
  };

  // 只判断后缀名为‘.png’和'.jpg','jpeg'
  const isImage = (fileName = '') => {
    const reg = /\.(png|jpg|jpeg)$/;
    return reg.test(fileName);
  }
  // 落地页地址(二级跳)
  const getLaunchUrl = (item = {}) => {
    const {
      spuId = '',
      landingPagePath = '',//落地页类型为图片/文件时图片地址
    } = item;

    const imgUrl = encodeURIComponent(landingPagePath)
    const redirect = window.location.origin + `/grainbuds/#/productSys/productRepository/detail/${getProDetailParams(item)}`
    return `${HTML_URL}?isImg=${true}&imgUrl=${imgUrl}&redirect=${encodeURIComponent(redirect)}`
  }
  // 产品库-产品详情页
  const getProDetailParams = (item ={}) => {
    const jsonStr = encodeURIComponent(JSON.stringify({
      spuId: item.spuId,
      memberId: Utils.getCompanyId(),
      productName: item.spuName,
      rateType: '2', // 2机构配费
      fromType: '4',
    }))
    return jsonStr;
  }
  // 新窗口打开页面
  const openPage = (url = '') => {
    window.open(url,'_blank')
  }
  // 在新页面中查看图片
  const seeImageInHtml = (imgUrl = '') => {
    window.open(`${HTML_URL}?imgUrl=${imgUrl}`,'_blank')
  }
